import { defineMessages } from '@jutro/locale';

export default defineMessages({
    KeyContacts: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Key Contacts',
        defaultMessage: 'Key Contacts'
    },
    ClaimContact: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Claim Contact',
        defaultMessage: 'Claim Contact'
    },
    Phone: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Phone',
        defaultMessage: 'Phone:'
    },
    Email: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Email',
        defaultMessage: 'Email:'
    },
    claimConsultant: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Claim Consultant',
        defaultMessage: 'Claim Consultant'
    },
    ServiceProvider: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Service Provider',
        defaultMessage: 'Service Provider'
    },
    ext: {
        id: 'ml.claim.views.ml-claim-details-key-contact.ext',
        defaultMessage: 'ext'
    },
    RepairFacility: {
        id: 'ml.claim.views.ml-claim-details-key-contact.Repair Facility',
        defaultMessage: 'Repair Facility'
    }
});
